import * as actionTypes from "./actionTypes"
import axios from "axios"
export const authStart = ()=>{
    return {
        type : actionTypes.AUTH_START
    }
}
export const authFail =(error)=>{
    return{
        type:actionTypes.AUTH_FAIL,
        error:error
    }
}
export const authSuccess =(token , userId)=>{
    return{
        type:actionTypes.AUTH_SUCCESS,
        idToken:token,
        userId:userId
    }
}

export const  auth=(email , password , isSignup)=>{
return dispatch=>{

dispatch(authStart());

const authData={
    email:email,
    password:password,
    returnSecureToken:true
}

let url = "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDa-_PD5eu_wEPvL3p4LhwSpaOFw4gZxck"
if (!isSignup){
    url = "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDa-_PD5eu_wEPvL3p4LhwSpaOFw4gZxck"
}
axios.post(url,authData)
.then(response=>{
    console.log(response);
    dispatch(authSuccess(response.data.idToken , response.data.userId))
})
.catch(err=>{
    console.log(err);
    dispatch(authFail(err.response.data.error))
})

}
}



// WEBPACK FOOTER //
// ./src/store/action/auth.js